import { render, staticRenderFns } from "./Scheme.vue?vue&type=template&id=2f7994c2&scoped=true"
import script from "./Scheme.vue?vue&type=script&lang=js"
export * from "./Scheme.vue?vue&type=script&lang=js"
import style0 from "./Scheme.vue?vue&type=style&index=0&id=2f7994c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7994c2",
  null
  
)

export default component.exports